export default __webpack_public_path__ + "static/media/Task_Filled.1ebe3568.svg";